import { useState } from 'react';

interface NavigationProps {
  isFixed: boolean;
}

export default function Navigation({ isFixed }: NavigationProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false); // Close mobile menu after clicking
  };

  return (
    <>
      <nav
        className={`w-full z-50 transition-all duration-300 ${
          isFixed ? 'fixed top-0 bg-black/95 backdrop-blur-sm shadow-lg' : 'absolute top-0'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-5">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
              <img 
                src="https://static.readdy.ai/image/8247d44a15513d6329a08a3e6e69b51d/cc8a12b5bf00968df136d32511045f2c.png" 
                alt="MR Prime Ops Logo" 
                className="h-8 w-8 sm:h-10 sm:w-10 object-contain"
              />
              <span className="text-lg sm:text-xl font-bold tracking-tight">MR Prime Ops</span>
            </div>
            
            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-8">
              <button onClick={() => scrollToSection('hero')} className="text-sm font-medium hover:text-cyan-400 transition-colors whitespace-nowrap cursor-pointer">
                Home
              </button>
              <button onClick={() => scrollToSection('services')} className="text-sm font-medium hover:text-cyan-400 transition-colors whitespace-nowrap cursor-pointer">
                Services
              </button>
              <button onClick={() => scrollToSection('process')} className="text-sm font-medium hover:text-cyan-400 transition-colors whitespace-nowrap cursor-pointer">
                Process
              </button>
              <button onClick={() => scrollToSection('about')} className="text-sm font-medium hover:text-cyan-400 transition-colors whitespace-nowrap cursor-pointer">
                About
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-sm font-medium hover:text-cyan-400 transition-colors whitespace-nowrap cursor-pointer">
                Contact
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="px-5 py-2.5 bg-cyan-500 text-black text-sm font-semibold rounded-md hover:bg-cyan-400 transition-all whitespace-nowrap cursor-pointer"
              >
                Book Consult
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden p-2 cursor-pointer z-[60] relative"
            >
              <div className="w-6 h-6 flex flex-col justify-center items-center">
                <div className={`w-5 h-0.5 bg-white transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-1.5' : 'mb-1'}`}></div>
                <div className={`w-5 h-0.5 bg-white transition-all duration-300 ${isMenuOpen ? 'opacity-0' : 'mb-1'}`}></div>
                <div className={`w-5 h-0.5 bg-white transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`}></div>
              </div>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <div className="lg:hidden fixed inset-0 bg-black/95 backdrop-blur-sm z-[55] flex items-center justify-center">
          <div className="flex flex-col items-center gap-8 text-center px-4">
            <button 
              onClick={() => scrollToSection('hero')} 
              className="text-2xl font-medium hover:text-cyan-400 transition-colors cursor-pointer py-3"
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('services')} 
              className="text-2xl font-medium hover:text-cyan-400 transition-colors cursor-pointer py-3"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('process')} 
              className="text-2xl font-medium hover:text-cyan-400 transition-colors cursor-pointer py-3"
            >
              Process
            </button>
            <button 
              onClick={() => scrollToSection('about')} 
              className="text-2xl font-medium hover:text-cyan-400 transition-colors cursor-pointer py-3"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('contact')} 
              className="text-2xl font-medium hover:text-cyan-400 transition-colors cursor-pointer py-3"
            >
              Contact
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="mt-4 px-8 py-4 bg-cyan-500 text-black text-xl font-semibold rounded-md hover:bg-cyan-400 transition-all cursor-pointer"
            >
              Book Consult
            </button>
          </div>
        </div>
      )}
    </>
  );
}
